import styled from 'styled-components'

export const Backdrop = styled.div<{ open: boolean }>`
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 35%);
  z-index: 50;
  opacity: ${({ open }) => (open ? 1 : 0)};
  transition: opacity 0.2s ease;
  pointer-events: ${({ open }) => (open ? 'auto' : 'none')};
`

export const DrawerPanel = styled.aside<{ open: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 75vw;
  max-width: 75vw;
  min-width: 48rem;
  background: ${({ theme }) => theme.whiteColor};
  box-shadow: -0.5rem 0 1.5rem rgb(0 0 0 / 12%);
  transform: translateX(${({ open }) => (open ? '0' : '100%')});
  transition: transform 0.25s ease;
  z-index: 50;
  overflow-y: auto;
  overscroll-behavior: contain;
`

export const CloseButton = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  width: 2.25rem;
  height: 2.25rem;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${({ theme }) => theme.grey200Color};
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 0.125rem solid ${({ theme }) => theme.primaryColor};
    outline-offset: 0.125rem;
  }
`

export const DrawerBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 0 2rem 2.5rem;
`

// Groups the AI Rationale banner and the ScoreBreakdown "tucked card" into one
// stacking context with no flex gap between them, so the card can slide UP
// behind the banner (its own negative margin-top) and the banner — given the
// higher z-index below — paints OVER the card's tucked-in top edge. The card
// (ScoreBreakdownRoot) claims z-index:1; BannerLayer claims z-index:2. This
// tuck is set up entirely here, leaving AIRationaleBanner's own styles
// untouched (BRAND-9489 hard constraint).
export const ScoreSummaryStack = styled.div`
  display: flex;
  flex-direction: column;
`

export const BannerLayer = styled.div`
  position: relative;
  z-index: 2;
`

// Insets the tucked card so it reads NARROWER than the banner above it
// (mock: banner inset 24px, card inset 38px → the card sits ~14px/0.875rem
// further in on each side).
export const ScoreBreakdownTuck = styled.div`
  padding: 0 0.875rem;
`

export const DrawerSection = styled.div``

export const DrawerSectionTitle = styled.h3`
  margin: 0 0 0.75rem;
  font-family: Rubik, verdana, sans-serif;
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 1.5rem;
  letter-spacing: 0.0187rem;
  text-transform: uppercase;
  color: #4d4d4d;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`
